import { allCountries } from 'country-region-data';
import React, { useEffect } from 'react';

import { NameValuePair } from '../NameValuePair';

import SelectDropdown, { SelectOption, SelectOptionChangeParam } from './SelectDropdown';

interface CountrySelectProps {
  label: string;
  value: NameValuePair | null;
  onChange: (selectedCountry: NameValuePair | null, stateOptions: NameValuePair[]) => void;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  error?: string;
  touched?: boolean;
  showErrorBeforeBlur?: boolean;
  onBlur?: () => void;
}

function CountrySelect({
  label,
  value,
  onChange,
  required,
  disabled,
  placeholder,
  error,
  touched,
  showErrorBeforeBlur,
  onBlur,
}: Readonly<CountrySelectProps>) {
  const [options, setOptions] = React.useState<SelectOption[]>([]);

  useEffect(() => {
    const countryOpts = allCountries.map(([countryName, countryCode]) => {
      return {
        value: countryCode,
        label: countryName,
      };
    });

    const usIndex = countryOpts.findIndex((country) => country.value === 'US');
    if (usIndex) {
      const usOption = countryOpts.splice(usIndex, 1)[0];
      countryOpts.unshift(usOption);
    }

    setOptions(countryOpts);
  }, []);

  const handleCountryChange = (selectedCountry: SelectOptionChangeParam) => {
    if (Array.isArray(selectedCountry)) {
      return;
    }

    let stateOptions: NameValuePair[] = [];

    if (selectedCountry) {
      const countryData = allCountries.find(([countryName, countryCode]) => countryCode === selectedCountry.value);

      if (countryData) {
        const regions = countryData[2];

        if (regions && regions.length > 0) {
          stateOptions = regions.map(([regionName, regionCode]) => ({
            value: regionCode,
            label: regionName,
          }));
        }
      }
    }

    onChange(selectedCountry, stateOptions);
  };

  return (
    <SelectDropdown
      disableSorting
      label={label}
      options={options}
      onChange={handleCountryChange}
      value={value}
      required={required}
      disabled={disabled}
      placeholder={placeholder}
      error={error}
      touched={touched}
      showErrorBeforeBlur={showErrorBeforeBlur}
      onBlur={onBlur}
    />
  );
}

export default CountrySelect;
